module.exports = __webpack_public_path__ + "img/1.efb3f25e.png";